import React from 'react';
import Grid from '@material-ui/core/Grid';
import Text from 'UI/components/atoms/Text';

import { useStyles } from './styles';

/**
 * @param {Object} props
 * @param {Array<DialogBodyDetailsType>} props.details
 */
const DialogDetailsBody = ({ details }) => {
  const classes = useStyles();
  const showRow = visible => typeof visible === 'undefined' || visible;

  return (
    <>
      {details.map(
        ({ title, detail, visible }) =>
          showRow(visible) && (
            <Grid key={title} container item alignItems="flex-start" wrap="nowrap">
              <Text text={title} className={classes.title} />
              <Text text={detail} fontSize={16} />
            </Grid>
          )
      )}
    </>
  );
};

export default DialogDetailsBody;
